// removed by extract-text-webpack-plugin
module.exports = {"link":"_3Z47e","text":"oRFem"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/RecurringPaymentsButtons/RecurringPaymentsButtons.scss
// module id = ./src/components/Page/RecurringPaymentsButtons/RecurringPaymentsButtons.scss
// module chunks = 4